import { isAnonymousUser } from 'bookings-shared/lib/c2/utils/isAnonymousUser';
import type { FreeBusyRow } from 'owa-freebusy-cache';
import { isCacheInitialized, initializeCache } from 'owa-freebusy-cache';

export function initBookWithMeFreeBusyCache() {
    if (isAnonymousUser() || isCacheInitialized()) {
        return;
    }

    initializeCache(new Map<string, Map<string, FreeBusyRow>>([]));
}
